import React, { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS, FONT } from './tokens';
import { MaterialSymbol } from './MaterialSymbol';
import { YellowCtaButton } from './YellowCtaButton';

export interface EmptyCardProps {
  icon: string;
  title: string;
  body: string;
  cta?: { label: string; onClick?: () => void; href?: string };
}

export const EmptyCard = ({
  icon,
  title,
  body,
  cta,
}: EmptyCardProps): ReactElement => (
  <Box
    sx={{
      backgroundColor: COLORS.white,
      border: `1px solid ${COLORS.cardBorder}`,
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      alignItems: 'center',
      px: '32px',
      py: '48px',
      width: '100%',
    }}
  >
    <MaterialSymbol name={icon} size={32} color={COLORS.muted} />
    <Typography
      sx={{
        fontFamily: FONT,
        fontWeight: 600,
        fontSize: '16px',
        color: COLORS.headingDark,
        lineHeight: 'normal',
        textAlign: 'center',
      }}
    >
      {title}
    </Typography>
    <Typography
      sx={{
        fontFamily: FONT,
        fontWeight: 400,
        fontSize: '14px',
        color: COLORS.muted,
        lineHeight: '20px',
        textAlign: 'center',
      }}
    >
      {body}
    </Typography>
    {cta && (
      <Box mt="4px">
        <YellowCtaButton onClick={cta.onClick} href={cta.href} height={45}>
          {cta.label}
        </YellowCtaButton>
      </Box>
    )}
  </Box>
);
